<template>
    <el-dialog title="院校对比结果" :visible="true" :modal="true" :show-close="false" class="dialog-box dialog-compare">
        <img src="../assets/images/close.png" alt="关闭" @click="closeHandler" class="close-img">
        <img src="../assets/images/compare.png" alt="背景图" class="dialog-img">
        <GeminiScrollbar>
            <el-row class="compare-table" type="flex" justify="space-between">
                <el-col>
                    <el-row v-for="(item,index) in headers" :key="index" class="compare-title">
                        {{(index == '1' ||index == '2' || index == '3' || index == '4') && schoolList.length > 0 ? schoolList[0].year + item.label : item.label}}
                    </el-row>
                </el-col>
                <el-col v-for="(item,index) in schoolList" :key="index">
                    <el-row class="compare-content">
                        <el-image :src="item.logo" alt="大学logo">
                            <div slot="error" class="image-slot">
                                <img src="../assets/images/scl_default.png" alt="大学logo">
                            </div>
                        </el-image>
                        <!-- <img :src="'https://gaokao.zmpajx.com/pic/' + item.scl_id + '.jpg'" alt="学校logo" class="school-logo"> -->
                        <div class="school-name">{{item.scl_name}}</div>
                        <div class="compare-count">NO.{{index+1}}</div>
                        <div class="close-school">
                            <img src="../assets/images/close_school.png" alt="删除学校" @click="removeSchool(item.scl_id,index)">
                        </div>
                    </el-row>
                    <el-row class="compare-content">
                        {{item.li_score ? item.li_score: '--'}}
                    </el-row>
                    <el-row class="compare-content">
                        {{item.wen_score ? item.wen_score: '--'}}
                    </el-row>
                    <el-row class="compare-content">
                        {{item.li_plan ? item.li_plan: '--'}}
                    </el-row>
                    <el-row class="compare-content">
                        {{item.wen_plan ? item.wen_plan: '--'}}
                    </el-row>
                    <el-row class="compare-content">
                        {{item.province_name == '北京' || item.province_name == '天津' || item.province_name == '上海' || item.province_name == '重庆' ? '' : item.province_name}}{{item.city_name}}
                    </el-row>
                    <el-row class="compare-content">
                        {{item.scl_create_year ? item.scl_create_year: '--'}}
                    </el-row>
                    <el-row class="compare-content">
                        {{item.school_nature ? item.school_nature: '--'}}
                    </el-row>
                    <el-row class="compare-content">
                        {{item.scl_belong ? item.scl_belong: '--'}}
                    </el-row>
                    <el-row class="compare-content">
                        {{item.school_nature_type ? item.school_nature_type: '--'}}
                    </el-row>
                    <el-row class="compare-content">
                        {{item.school_type ? item.school_type: '--'}}
                    </el-row>
                    <el-row class="compare-content">
                        {{item.f985 == '1' ? '是' : '否'}}
                    </el-row>
                    <el-row class="compare-content">
                        {{item.f211 =='1' ? '是': '否'}}
                    </el-row>
                    <el-row class="compare-content">
                        {{item.dual_class != '38003' && item.dual_class ? '是': '否'}}
                    </el-row>
                    <el-row class="compare-content">
                        {{item.num_subject ? item.num_subject: '--'}}
                    </el-row>
                    <el-row class="compare-content">
                        {{item.num_doctor ? item.num_doctor: '--'}}
                    </el-row>
                    <el-row class="compare-content">
                        {{item.num_master ? item.num_master: '--'}}
                    </el-row>
                    <el-row class="compare-content">
                        {{item.gender_rate ? item.gender_rate.split(":")[0] + '%' : '--'}}
                    </el-row>
                    <el-row class="compare-content">
                        {{item.gender_rate ? item.gender_rate.split(":")[1] + '%' : '--'}}
                    </el-row>
                    <el-row class="compare-content">
                        {{item.scl_area ? item.scl_area + '亩' : '--'}}
                    </el-row>
                    <el-row class="compare-content">
                        {{item.promote_rate ? item.promote_rate + '%' : '--'}}
                    </el-row>
                    <el-row class="compare-content">
                        {{item.job_rate ? item.job_rate + '%' : '--'}}
                    </el-row>
                    <el-row class="compare-content">
                        {{item.out_rate ? item.out_rate + '%' : '--'}}
                    </el-row>
                </el-col>
                <el-col v-for="(item,index) in (4-schoolList.length)" :key="'id_' + index">
                    <el-row class="compare-content">
                        <el-button class="school-compare-btn" @click="addCompareSchool">
                            <img src="../assets/images/add.png" alt="加入对比">
                            加入对比
                        </el-button>
                    </el-row>
                    <el-row class="compare-content" v-for="(item1,index1) in 22" :key="index1">
                    </el-row>
                </el-col>
            </el-row>
        </GeminiScrollbar>
    </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
import { schoolDiff } from '@/api/school'
import { getSearchDic } from "@/api/zhiyuan"
export default {
    data () {
        return {
            headers: [
                {
                    label: '院校',
                },
                {
                    label: '分数线(本科-理)',
                },
                {
                    label: '分数线(本科-文)',
                },
                {
                    label: '招生计划(本科-理)',
                },
                {
                    label: '招生计划(本科-文)',
                },
                {
                    label: '所在地区',
                },
                {
                    label: '创办时间',
                },
                {
                    label: '办学性质',
                },
                {
                    label: '隶属于',
                },
                {
                    label: '学科层次',
                },
                {
                    label: '院校类型',
                },
                {
                    label: '985',
                },
                {
                    label: '211',
                },
                {
                    label: '双一流',
                },
                {
                    label: '国家重点学科',
                },
                {
                    label: '博士点',
                },
                {
                    label: '硕士点',
                },
                {
                    label: '男生占比',
                },
                {
                    label: '女生占比',
                },
                {
                    label: '学校面积',
                },
                {
                    label: '升学率',
                },
                {
                    label: '就业率',
                },
                {
                    label: '出国率',
                },
                
            ],
            schoolList: [],
            showStr: true,
            type_edu: {}
        }
    },
    computed: {
        ...mapState({
            compareSchoolList: state => state.user.compareSchoolList,
        })
    },
    mounted() {
        this.getSearchDicHandler();
        this.schoolDiff();
    },
    methods: {
        getSearchDicHandler() {
            try {
                getSearchDic().then(res => {
                    if (res.status != 200 || !res) {
                        return
                    }
                    res.data.edu_type.map( item => {
                        this.type_edu[item.dic_code] = item.dic_value
                    })
                }).catch(error => {
                    console.log(error);
                })
            } catch (error) { console.log(error) }
        },
        closeHandler() {
            this.$store.commit('user/COMPARESTATUS', false);
        },
        removeSchool(scl_id,index) {
            let findIndex = this.compareSchoolList.indexOf(scl_id);
            this.compareSchoolList.splice(findIndex, 1);
            this.schoolList.splice(index, 1);
        },
        addCompareSchool() {
            this.$store.commit('user/COMPARESTATUS', false);
            if(this.$route.fullPath != "/school") {
                this.$router.push({
                    path: '/school'
                })
            }
        },
        schoolDiff() {
            schoolDiff(this.compareSchoolList.join(","),localStorage.getItem("area")).then(res => {
                let schoolList = [];
                res.data.forEach((item,index) => {
                    let obj = {};
                    let school_type = '';
                    let school_nature = '';
                    obj = item;
                    if(item.scl_type == '5000') {
                        school_type = '综合'
                    } else  if(item.scl_type == '5001') {
                        school_type = '理工'
                    } else  if(item.scl_type == '5002') {
                        school_type = '农林'
                    } else  if(item.scl_type == '5003') {
                        school_type = '医药'
                    } else  if(item.scl_type == '5004') {
                        school_type = '师范'
                    } else  if(item.scl_type == '5005') {
                        school_type = '语言'
                    } else  if(item.scl_type == '5006') {
                        school_type = '财经'
                    } else  if(item.scl_type == '5007') {
                        school_type = '政法'
                    } else  if(item.scl_type == '5008') {
                        school_type = '体育'
                    } else  if(item.scl_type == '5009') {
                        school_type = '艺术'
                    } else  if(item.scl_type == '5010') {
                        school_type = '民族'
                    } else  if(item.scl_type == '5011') {
                        school_type = '军事'
                    } else {
                        school_type = '其他'
                    }
                    if(item.scl_nature == '36000') {
                        school_nature = '公办'
                    } else if(item.scl_nature == '36001') {
                        school_nature = '民办'
                    } else if(item.scl_nature == '36002') {
                        school_nature = '中外合作办学'
                    }
                    // if(item.scl_nature_type == '6000') {
                    //     school_nature_type = '普通本科'
                    // } else if(item.scl_nature_type == '6001') {
                    //     school_nature_type = '普通专科'
                    // } else if(item.scl_nature_type == '6002') {
                    //     school_nature_type = '中外合作办学'
                    // }
                    obj.school_type = school_type;
                    obj.school_nature = school_nature;
                    obj.school_nature_type = this.type_edu[item.scl_nature_type];
                    obj.logo = 'https://gaokao.zmpajx.com/pic/' + item.scl_id + '.jpg';
                    let findIndex =  this.compareSchoolList.indexOf(item.scl_id);
                    schoolList[findIndex] = obj;
                })
                this.schoolList = [...schoolList];
            })
        }
    }
}
</script>

<style lang='scss' scoped>
    .dialog-box {
        .close-img {
            width: 24px;
            height: 24px;
            position: absolute;
            right: 40px;
            top: 40px;
            z-index: 999;
        }
        .compare-table {
            position: relative;
            width: 99%;
        }
        .compare-title,.compare-content {
            background-color: #F5F7FA;
            height: 59px;
            width: 210px;
            text-align: center;
            line-height: 59px;
            color: #5e6166;
            font-size: 16px;
            border-bottom: 1px solid #e1e4eb;
            border-right: 1px solid #e1e4eb;
            top: 110px;
        }
        .compare-content {
            background-color: #fff!important;
            position: relative;
            width: 172px;
        }
        .compare-title:first-child {
            height: 109px;
            line-height: 109px;
            position: fixed;
            top: calc(50% - 300px);
            z-index: 10000;
            border-top: 1px solid #e1e4eb;

        }
        .compare-title:not(:first-child) { 
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
        .compare-content:not(:first-child) { 
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
        .compare-content:first-child {
            height: 109px;
            line-height: 16px;
            position: fixed;
            top: calc(50% - 300px);
            z-index: 10000;
            border-top: 1px solid #e1e4eb;
        }
        .el-image,.el-image img {
            width: 48px;
            height: 48px;
            margin-top: 12px;
        }
        .el-image .image-slot img {
            margin-top: 0px;
        }
        .school-name {
            font-size: 14px;
            color: #2c2e33;
            font-weight: 600;
            margin-top: 6px;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            overflow: hidden;
            /*! autoprefixer: off */
            -webkit-box-orient: vertical;
            /*! autoprefixer: on */
        }
        .compare-count {
            width: 36px;
            height: 23px;
            line-height: 23px;
            background: linear-gradient(270deg,#3272ff, #60aaff 99%);
            border-radius: 0px 0px 6px 0px;
            font-weight: 600;
            color: #ffffff;
            font-size: 12px;
            position: absolute;
            top: 0;
            left: -1px;
        }
        .close-school {
            width: 22px;
            height: 22px;
            background: #f0f2f5;
            position: absolute;
            top: 0;
            right: 0;
            text-align: center;
            img {
                width: 10px;
                height: 10px;
            }
        }
    }
</style>